// Back-compat wrapper. All AI traffic goes through useAI -> `ai-features`
// (Google Gemini). Kept so existing call sites need no changes.
import { useAI, type AIResult } from "@/hooks/useAI";

export interface ClaudeCallParams {
  feature: string;
  input?: string;
  dataset?: any;
  options?: Record<string, any>;
}

export type ClaudeResult<T = any> = AIResult<T>;

export const useClaudeAI = () => {
  const { call, isLoading, lastResult } = useAI();
  return {
    call: <T = any>(params: ClaudeCallParams) => call<T>(params),
    isLoading,
    lastResult,
  };
};
